import { useFormatter } from 'next-intl';

export const FormattedDate = ({dateString}:{dateString:string}) => {
  const format = useFormatter();
  const date = new Date(dateString);

  return date && (
    <label>{format.dateTime(date, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}</label>
  );
}